<ion-card (click)="toggleAccordion()" class="ion-no-margin">
  <ion-item>
    <ion-label>{{ title }}</ion-label>
    <ion-icon name="{{ (this.opened ? 'remove' : 'add') }}" slot="end"></ion-icon>
  </ion-item>
  <ion-card-content *ngIf="opened">{{ text }}</ion-card-content>
</ion-card>